import { Deserializable } from "./deserializable";
import { TagEntry } from "./TagEntry";
import { Subject } from "rxjs";
import { Alarm } from "./Alarm";

export class Signaltag implements Deserializable {
	tagIndex: { description: string };
	customerTagAlias: string;
	dataSourceId: number;
	datasourceName: string;
	engUnit: string;
	engUnitsId: number;
	isExternal: boolean;
	rangeMax: number;
	rangeMin: number;
	step: boolean;
	tagAlias: string;
	tagDescription: string;
	tagId: number;
	tagIndexId: number;
	tagName: string;
	tagType: string;
	value: number;
	tagTypeId: number;
	ldsMeta: any | { tag: string };
	realTimeTimeout;
	realTime = false;
	isEvent = false;
	lastValue: number;
	alarms: Alarm[] = [];
	tagData: Array<TagEntry> = [];
	lastTimeStamp: string | number;
	operationalProfile: {
		definition: string;
	};

	trendExplorer = {
		added: false,
		chartSerieRef: null,
		traceColor: null,
		lastValue: null,
		lastTimeStamp: null,
		originalTimeStamp: null,
		dataSubscription: null,
		recentlyAdded: false,
		loading: false,
		streamSub: null,
		dataSub: null,
		buffer: [],
		traceIndex: null,
		change: null,
		visible: true,
	};
	opBuffer: TagEntry[] = [];

	timeZone: string;

	txBuffer = [];
	txBufferEvent = new Subject<boolean>();

	get displayName() {
		return this.tagName;
	}

	deserialize(raw: any): this {
		Object.assign(this, raw);
		try {
			if (raw.tagData) {
				this.tagData = (raw.tagData as any).map(function (tagData) {
					if (tagData.quality !== 192) {
						tagData.value = null;
					}
					return new TagEntry(tagData.siteTime, tagData.value, false);
				});
			}
			if (raw.tag) {
				this.tagIndex = raw.tag.tagIndex;
			}
		} catch (e) {
			console.log(e);
		}

		return this;
	}

	setTxChartRef(ref) {
		this.trendExplorer.chartSerieRef = ref;
		this.trendExplorer.traceColor = ref.color;
	}

	resetTx() {
		this.trendExplorer.added = false;
		this.trendExplorer.traceColor = null;
		this.trendExplorer.traceIndex = null;
		this.trendExplorer.loading = false;
		this.trendExplorer.lastValue = null;
		this.trendExplorer.lastTimeStamp = null;
	}

	getLdsMatcher() {
		return this.tagAlias;
	}
}

export class SignalTag2 implements Deserializable {
	alarmLimits: any;
	customerTagAlias: string;
	description: string;
	displayDigits: string;
	engineeringUnit: string;
	engineeringUnitFromId: string;
	isExternal: boolean;
	isRmsTag: boolean;
	isStep: boolean;
	rangeMax: any;
	rangeMin: any;
	stateIndicatorId: any;
	subsystemId: number;
	tagAlias: string;
	tagId: number;
	tagIndexId: number;
	tagName: string;
	tagTypeId: number;
	validatedBy: any;
	validatedOn: any;

	alarms: Alarm[] = [];
	dailyAlarms: { [key: string]: Alarm[] };

	subsystem: string;

	deserialize(raw: any): this {
		Object.assign(this, raw);
		return this;
	}
}



// WEBPACK FOOTER //
// ./src/models/trend-live-models/OPTag.ts